import React, { useEffect, useState, useMemo } from "react";
import "./index.scss";
import HeaderAction from "../components/HeaderAction";
import TitleLogo from "../components/TitleLogo";
import { useNavigate } from "react-router-dom";
import PATH from "../../../../config/PATH";
import {
  ID_TAB_MINI_GAME,
  useNewYear2025Theme,
  useThadingyutTheme,
  // IS_EVENT_THADINGYUT_2025_THEME,
} from "../../../../helper/const";
import { useDispatch, useSelector } from "react-redux";
import { curStateMiniGame } from "../../../../Redux/selector";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import ActionComponent from "../components/Action";
import MissionsList from "../components/MissionsList";
import ComponentLink from "../components/ComponentLink";
import iconHome from "../../../../assets/images/Mini-Game/iconHome.png";
import iconHistory from "../../../../assets/images/Mini-Game/icon-history.png";
import { Button } from "antd";
import logoPrizeCollection from "../../../../assets/images/Mini-Game/logo-prize-collection.png";
import logoPrizeCollectionEn from "../../../../assets/images/Mini-Game/logo-prize-collection-en.png";
import iconGift from "../../../../assets/images/Mini-Game/icon-gift.svg";
import iconPiece from "../../../../assets/images/Mini-Game/icon-piece.svg";
import iconLixi from "../../../../assets/images/Mini-Game/icon-li-xi.png";
import iconFlyIcon from "../../../../assets/images/Mini-Game/icon-fly-coin.png";
import frameCap from "../../../../assets/images/Mini-Game/Frame-cap.png";
import frame1 from "../../../../assets/images/Mini-Game/Frame-1.png";
import frame3 from "../../../../assets/images/Mini-Game/Frame-3.png";
import frame2 from "../../../../assets/images/Mini-Game/Frame-2.png";
import {
  getDataPrizeCollectionMiniGame,
  setOpenPopupFooter,
} from "../../../../Redux/futures/mini-game/action";
import PopupEarnMore from "../components/PopupFooter/PopupEarnMore";
import iconSuperPrize from "../../../../assets/images/Mini-Game/super-prize-icon.png";
import iconSuperPrizeNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-piece-super.png";
import PopupActivityHis from "../components/PopupFooter/PopupActivityHis";
import styled from "styled-components";
import lotusIcon from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/lotus-icon.png";
import iconHistory3d from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/icon-history-3d.png";
import iconHome3d from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/icon-home-3d.png";
import iconGift3d from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/prize-icon.png";
import iconPiece3d from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/piece-icon.png";
import frame1NewYear from "../../../../assets/images/Mini-Game/new-year-2025/Frame-1.png";
import frame2NewYear from "../../../../assets/images/Mini-Game/new-year-2025/Frame-2.png";
import frame3NewYear from "../../../../assets/images/Mini-Game/new-year-2025/Frame-3.png";
import footerTree from "../../../../assets/images/Mini-Game/new-year-2025/footer-tree.png";
import iconHomeNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-home.png";
import iconHistoryNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-history.png";
import iconGiftNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-prize.png";
import iconPieceNewYear from "../../../../assets/images/Mini-Game/new-year-2025/icon-piece.png";

export default function MiniGamePrizeCollection() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isShowPopupHistory, setIsShowPopupHistory] = useState(false);
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();

  const { dataPrizeCollectionMini = [] } = useSelector(curStateMiniGame);
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  useEffect(() => {
    dispatch(getDataPrizeCollectionMiniGame());
  }, []);

  const handleTopage = (id) => {
    navigate(`${PATH.MINI_GAME}/${id}`);
  };

  const handleTakePrize = (data) => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}/${data.id}`);
  };

  const dataActive = useMemo(() => {
    return dataPrizeCollectionMini.sort(
      (a, b) => Number(a.rank) - Number(b.rank)
    );
  }, [dataPrizeCollectionMini]);

  const dataLink = [
    {
      id: 1,
      srcImg: IS_EVENT_THADINGYUT_2025_THEME ? iconHistory3d : iconHistory,
      action: () => setIsShowPopupHistory(true),
      content: t("mini_game.homepage.history"),
      height: 88,
    },
    {
      id: 2,
      srcImg: IS_EVENT_THADINGYUT_2025_THEME ? iconHome3d : iconHome,
      action: () => handleTopage(ID_TAB_MINI_GAME.home),
      content: t("mini_game.homepage.home"),
      height: 88,
    },
  ];

  const dataLinkNewYear = [
    {
      id: 1,
      srcImg: iconHistoryNewYear,
      action: () => setIsShowPopupHistory(true),
      content: t("mini_game.homepage.history"),
      height: 88,
    },
    {
      id: 2,
      srcImg: iconHomeNewYear,
      action: () => handleTopage(ID_TAB_MINI_GAME.home),
      content: t("mini_game.homepage.home"),
      height: 88,
    },
  ];

  const bg_lang_logoPrizeCollection = i18n.language === 'en' ? logoPrizeCollectionEn : logoPrizeCollection

  return (
    <>
      {isShowPopupHistory ? (
        <PopupActivityHis
          isShowPopupHistory={isShowPopupHistory}
          setIsShowPopupHistory={setIsShowPopupHistory}
        />
      ) : null}
      <div
        className={`container-minigame prize-collection main-prize-mini ${IS_EVENT_THADINGYUT_2025_THEME
          ? "thadingyut-theme"
          : IS_EVENT_NEW_YEAR_2025_THEME
            ? "new-year-25-theme"
            : ""
          }`}
      >
        <div className='minigame-home-header position-relative'>
          <HeaderAction />
          <TitleLogo logo={bg_lang_logoPrizeCollection} />
          <ActionComponent />
        </div>
        <Div className='mission-container-minigame__body position-relative'>
          <div className='frame-container'>
            <div className='prize-grid-wrapper'>
              {!IS_EVENT_NEW_YEAR_2025_THEME && (
                <img src={frameCap} alt='' className='frame-cap' />
              )}
              <img
                src={IS_EVENT_NEW_YEAR_2025_THEME ? frame1NewYear : frame1}
                alt=''
                className='frame-image frame-top'
              />
              <img
                src={IS_EVENT_NEW_YEAR_2025_THEME ? frame2NewYear : frame2}
                alt=''
                className='frame-image'
              />
              {!IS_EVENT_NEW_YEAR_2025_THEME && (
                <img src={iconLixi} alt='' className='icon-li-xi' />
              )}
              {!IS_EVENT_NEW_YEAR_2025_THEME && (
                <img src={iconFlyIcon} alt='' className='icon-fly-coin' />
              )}
              {/* <div className='prize-grid-inner-wrapper'> */}

              {/* </div> */}
              <img
                src={IS_EVENT_NEW_YEAR_2025_THEME ? frame3NewYear : frame3}
                alt=''
                className='frame-image frame-bottom'
              />
            </div>
            <div className='prize-grid'>
              {dataActive.map((item = {}, index) => (
                <div className='prize-item' key={`prize_${item.id}`}>
                  <div
                    className={`prize-image-wrapper  scale-hover-item ${item.is_super_prize == 1 ? "super-prize" : ""
                      }`}
                    onClick={() => handleTakePrize(item)}
                  >
                    {item.is_super_prize == 1 ? (
                      <img
                        src={
                          IS_EVENT_NEW_YEAR_2025_THEME
                            ? iconSuperPrizeNewYear
                            : iconSuperPrize
                        }
                        alt=''
                        className='icon-super-prize'
                      />
                    ) : null}
                    <img src={item.image} alt='' className='prize-image' />
                  </div>
                  <button className='prize-button'>
                    <span>
                      {item.collected < 10 ? "0" : ""}
                      {item.collected || 0} /{" "}
                      {item.piece_number < 10 ? "0" : ""}
                      {item.piece_number}
                    </span>
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className='lower-container'>
            <ComponentLink
              dataLink={
                IS_EVENT_NEW_YEAR_2025_THEME ? dataLinkNewYear : dataLink
              }
            />

            <div className='btn-group'>
              <Button
                className='btn-item btn-item-collect btn-item-take-prize scale-hover-item'
                onClick={() => handleTopage(ID_TAB_MINI_GAME.takePrize)}
              >
                {IS_EVENT_THADINGYUT_2025_THEME ? (
                  <img srcSet={`${iconGift3d} 2x`} alt='' />
                ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
                  <img srcSet={`${iconGiftNewYear} 2x`} alt='' />
                ) : (
                  <img src={iconGift} alt='' />
                )}
                <span style={{ marginLeft: "3px" }}>
                  {t("mini_game.homepage.take_prize")}
                </span>
              </Button>

              <Button
                className='btn-item btn-item-collect btn-item-piece-collection scale-hover-item'
                onClick={() => handleTopage(ID_TAB_MINI_GAME.pieceCollection)}
              >
                {IS_EVENT_THADINGYUT_2025_THEME ? (
                  <img srcSet={`${iconPiece3d} 2x`} alt='' />
                ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
                  <img srcSet={`${iconPieceNewYear} 2x`} alt='' />
                ) : (
                  <img src={iconPiece} alt='' />
                )}
                <span style={{ marginLeft: "3px" }}>
                  {t("mini_game.homepage.piece_collection")}
                </span>
              </Button>
            </div>

            <MissionsList title={t("mini_game.pop_up_earn_more.title")}>
              <PopupEarnMore
                isMissionMini
                className='prize-collection__Earn-more-coins'
              />
            </MissionsList>
          </div>
          {IS_EVENT_THADINGYUT_2025_THEME && (
            <LotusIconContainer>
              <img src={lotusIcon} alt='Lotus Icon' />
            </LotusIconContainer>
          )}
          {IS_EVENT_NEW_YEAR_2025_THEME && (
            <div
              style={{
                position: "absolute",
                zIndex: 1,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                pointerEvents: "none",
              }}
            >
              <img
                src={footerTree}
                alt='footer-tree'
                className='footer-tree-new-year-25-theme'
                style={{
                  width: "100%",
                }}
              />
            </div>
          )}
        </Div>
      </div>
    </>
  );
}

const LotusIconContainer = styled.div`
  position: absolute;
  left: 0;
  transform: rotate(17deg) translate(-30%, -19%);
  z-index: 0;
  pointer-events: none;

  @media (max-width: 768px) {
    transform: rotate(17deg) translate(-30%, -13%);
    img {
      max-width: 85%;
    }
  }
`;

const Div = styled.div`
 @media (max-width: 512px) {
     .btn-item-take-prize, .btn-item-piece-collection {
      text-align: center !important;
      margin: 0 auto !important;
      display: flex !important;
      flex-direction: column !important;
    }
  }
`